import { styled } from '@mui/material/styles';

const prefix = 'HusaPageSize';
const classes = {
  label: `${prefix}-label`,
  select: `${prefix}-select`
};
const PageSize = styled('div')(({ theme }) => ({
  [`& .${classes.label}`]: {
    position: 'absolute',
    color: theme.palette.action.active,
    bottom: theme.spacing(2)
  },
  [`& .${classes.select}`]: {
    paddingLeft: 42
  }
}));

export { classes, PageSize };
